export enum VehicleTypeEnum {
  T_4x2 = '4x2',
  T_6x2 = '6x2 | 6x4',
  T_8x2 = '8x2',
  T_1x2 = '1 eixo 2 pneus',
  T_1x4 = '1 eixo 4 pneus',
  T_2x4 = 'Carro | 2 eixos 4 pneus',
  T_2x8 = '2 eixos 8 pneus',
  T_3x6 = '3 eixos 6 pneus',
  T_3x12 = '3 eixos 12 pneus',
  T_4x8 = '4 eixos 8 pneus',
  T_4x16 = '4 eixos 16 pneus',
  T_6x24 = '6 eixos 24 pneus',
}

export const VehicleTypeTireCount: Record<keyof typeof VehicleTypeEnum, number> = {
  T_4x2: 6,
  T_6x2: 10,
  T_8x2: 12,
  T_1x2: 2,
  T_1x4: 4,
  T_2x4: 4,
  T_2x8: 8,
  T_3x6: 6,
  T_3x12: 12,
  T_4x8: 8,
  T_4x16: 16,
  T_6x24: 24,
};
